<template>
  <div>
    <QSpinner
      v-if="loading"
      class="q-mr-md center"
      :size="30"
    />
    <QForm
      v-else
      class="q-gutter-md"
      @submit="save"
    >
      <QInput
        v-model="topic.name"
        dense
        filled
        label="Name"
        lazy-rules
        :rules="[
          (val) => (val && val.length > 0) || `${topicType} Name must exist`,
        ]"
        square
        type="text"
      />

      <template v-if="isTopic">
        <label>Sub Topics</label>
        <VueTagsInput
          v-if="topic"
          v-model="subTopicInput"
          :add-on-key="[13, 188, 9]"
          class="streem-input form-input q-ml-md q-mt-md"
          placeholder="Sub-Topics"
          :separators="[';', ',']"
          :tags="subTopics"
          @tags-changed="(newTags) => (subTopics = newTags)"
        >
          <template #tag-actions="props">
            <QIcon
              class="q-ml-xs"
              name="ion-md-close-circle"
              @click="props.performDelete(props.index)"
            />
          </template>
        </VueTagsInput>
      </template>

      <QBtn
        color="primary"
        label="Save"
        type="submit"
      />
    </QForm>
  </div>
</template>

<script>
import { VueTagsInput } from "@sipec/vue3-tags-input";

import InsightsQualitativeTopic from "shared/resources/InsightsQualitativeTopic";

export default {
  name: "InsightsQualitativeTopicForm",
  components: {
    VueTagsInput,
  },
  props: {
    organisationId: {
      type: [Number, String],
      default: null,
    },
    globalGroupId: {
      type: [Number, String],
      default: null,
    },
    topicId: {
      type: [Number, String],
      default: null,
    },
    topicType: {
      type: String,
      required: true,
    },
  },
  emits: ["saved"],
  data() {
    return {
      subTopicInput: "",
      subTopics: [],
      topic: new InsightsQualitativeTopic({
        organisationId: this.organisationId,
        globalEntityGroupId: this.globalGroupId,
        topicType: this.topicType,
        label: "",
        subtopics: "[]",
      }),
      loading: false,
    };
  },
  computed: {
    isTopic() {
      return this.topicType === "Topic";
    },
  },
  mounted() {
    this.loadTopic();
  },
  methods: {
    async loadTopic() {
      try {
        this.loading = true;

        if (this.topicId) {
          const response = await InsightsQualitativeTopic.find(this.topicId);
          this.topic = response.data;

          this.subTopics = this.topic.subTopics.map((topic) => ({
            text: topic,
          }));
        }
      } catch (error) {
        this.$error("There was an error fetching the report.", error);
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.loading = true;

      if (
        this.isTopic &&
        !this.subTopics.some((subTopic) => subTopic.text === this.subTopicInput)
      ) {
        this.subTopics.push({ text: this.subTopicInput });
      }

      try {
        if (this.isTopic) {
          this.topic.subTopics = this.subTopics.map((topic) => topic.text);
        } else {
          this.topic.subTopics = [];
        }

        await this.topic.saveResource();

        this.$q.notify({
          message: `${this.topicType} saved successfully`,
          color: "grey-7",
          position: "bottom",
          closeBtn: "Dismiss",
        });

        this.$emit("saved", this.topic);
      } catch (error) {
        this.$error(
          "There was an error saving this topic. Check for errors and try again.",
          error
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.streem-input.vue-tags-input {
  max-width: none;
  background-color: $silver-white;

  :deep(.ti-new-tag-input) {
    background-color: #eee;
    font-size: 18px;
    color: #111;
    font-weight: normal;
  }

  :deep(.ti-input) {
    font-weight: normal;
    border: none;
  }

  :deep(.ti-tag) {
    &.tag-distributed-list {
      background-color: #6a6a6a;
    }

    &.tag-linked-list {
      background-color: #316899;
    }

    &.tag-recipient {
      background-color: $primary;
    }
  }

  :deep(.ti-deletion-mark) {
    background-color: $tv;
  }

  :deep(.ti-autocomplete) {
    font-weight: normal;
  }

  :deep(.ti-item.ti-selected-item) {
    background-color: $primary;
    color: white;
  }

  :deep(.ti-tags) {
    max-height: 400px;
    overflow-y: scroll;
  }
}
</style>
